import { ACTIONS } from "./actions";




const initialState = {
  reportOptions: null,
  isLoading: true
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.SET_REPORT_OPTIONS:
      return {
        ...state,
        reportOptions: payload,
        isLoading: false
      };
    case ACTIONS.API_ERROR:
      return {
        ...state,
        isLoading: false,
        reportData: null,
        error: payload
      };

    default:
      return state;
  }
};

export default reducer;
